export default "__VITE_ASSET__BOAeDsOh__"